import * as Sentry from "@sentry/react";

import { config } from "@shared/config";
import { getCurrentVersion } from "@shared/features/app/hooks/use-current-version";
import {
  scrubBreadcrumb,
  scrubEvent,
  scrubLog,
} from "@shared/utils/sentry-scrub";

export const initTracking = async () => {
  if (config.VITE_SENTRY_DSN) {
    const release = `${config.VITE_MC_APP_NAME}@${await getCurrentVersion()}`;

    console.debug("[Sentry] Initializing...", {
      release,
      environment: config.mode,
    });

    Sentry.init({
      release,
      dsn: config.VITE_SENTRY_DSN,
      sendDefaultPii: false,
      integrations: [
        Sentry.browserTracingIntegration(),
        // Screens show health data: replays must never record text, inputs or media.
        Sentry.replayIntegration({
          maskAllText: true,
          maskAllInputs: true,
          blockAllMedia: true,
        }),
      ],
      beforeSend: (event) => scrubEvent(event),
      beforeSendTransaction: (event) => scrubEvent(event),
      beforeBreadcrumb: (breadcrumb) => scrubBreadcrumb(breadcrumb),
      beforeSendLog: (log) => scrubLog(log),
      // Enable logs to be sent to Sentry
      enableLogs: true,
      tracesSampleRate: 0.2,
      tracePropagationTargets: [
        /localhost:3000/i,
        /api\.mobilitycare\.fr/i,
        /dev\.api\.mobilitycare.fr/i,
      ],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      environment: config.mode,
    });
  }
};

export { Sentry };
